export const SET_PROJECT_BUSINESS_TYPE_DATA = 'SET_PROJECT_BUSINESS_TYPE_DATA';
export const SET_PROJECT_CURRENCY_DATA = 'SET_PROJECT_CURRENCY_DATA';
export const SET_PROJECT_CLIENT_DATA = 'SET_PROJECT_CLIENT_DATA';
export const SET_PROJECT_DIVISION_DATA = 'SET_PROJECT_DIVISION_DATA';
export const SET_PROJECT_OPERATOR_DATA = 'SET_PROJECT_OPERATOR_DATA';
export const SET_PROJECT_DESIGNER_DATA = 'SET_PROJECT_DESIGNER_DATA';
export const SET_PROJECTS_DATA = 'SET_PROJECTS_DATA';
export const SET_SELECTED_PROJECT = 'SET_SELECTED_PROJECT';